module.exports = __webpack_public_path__ + "vue_assets/img/badge_deios_gold.16fb0e3b.png";